<template>
  <v-menu
    ref="timeMenu"
    :close-on-content-click="false"
    v-model="menu"
    :nudge-right="40"
    :return-value.sync="time"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      :error-messages="error"
      v-model="time"
      label="Hora de la cita"
      prepend-icon="mdi-clock-outline"
      box
      readonly
    ></v-text-field>
    <v-time-picker
      format="24hr"
      :allowed-hours="allowedHoursComputed"
      scrollable
      :allowed-minutes="allowedMinutesComputed"
      v-model="time"
      @change="$refs.timeMenu.save(time)"
    ></v-time-picker>
  </v-menu>
  <!-- <v-menu ref="menu" :close-on-content-click="false" v-model="menu" :nudge-right="40" :return-value.sync="time" lazy
        transition="scale-transition" offset-y full-width min-width="290px">
        <v-text-field slot="activator" v-model="time" :label="label" prepend-icon="mdi-clock-outline"  box readonly></v-text-field>
        <v-time-picker locale="es-es" format="24hr" :allowed-hours="allowedHours" :allowed-minutes="allowedMinutes" v-model="time" scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="menu = false">{{$t('Cancel')}}</v-btn>
            <v-btn flat color="primary" @click="$refs.menu.save(time)">{{$t('OK')}}</v-btn>
        </v-time-picker>
    </v-menu> -->
</template>

<script>
export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  props: {
    label: {
      type: String,
    },
    value: {
      type: [String, Object, Number],
    },
    allowedHours: {
      type: [Array, Object],
    },
    allowedMinutes: {
      type: [Array, Object],
    },
    error: {
      type: String,
    },
  },
  data() {
    return {
      time: this.value,
      menu: false,
    };
  },
  methods: {
    cancel() {
      this.menu = false;
      this.time = null;
    },
    allowedHoursComputed(t) {
      console.log('allowedHoursComputed', t, this.allowedHours);

      if (this.allowedHours && Array.isArray(this.allowedHours)) {
        return this.allowedHours.includes(String(t));
      } else {
        return true;
      }
    },
    allowedMinutesComputed(m) {
      console.log('allowedMinutesComputed', m, this.allowedMinutes);
      if (this.allowedMinutes && Array.isArray(this.allowedMinutes)) {
        return this.allowedMinutes.includes(String(m));
      } else {
        return true;
      }
    },
  },
  computed: {},

  watch: {
    time: function(val, oldVal) {
      this.$emit('input', this.time);
    },
    value: function(val) {
      this.time = val;
    },
  },
};
</script>

<style></style>
